import { Stack, styled } from '@mui/material';
import { omitForwardedProps } from 'common/utils';

type Props = {
  /** @default 'default' */
  background?: 'default' | 'paper';
  sticky?: boolean;
};

export const ActionButtonWrapper = styled(Stack, {
  shouldForwardProp: omitForwardedProps<Props>('background', 'sticky'),
})<Props>(({ theme: { spacing, palette, breakpoints }, background = 'default', sticky = false }) => ({
  backgroundColor: palette.background[background],
  flexDirection: 'column',
  padding: spacing(2, 0),
  gap: spacing(1),

  ...(sticky && {
    position: 'sticky',
    bottom: 0,
  }),

  // No `flex: 1` on the phone column. There `flex-basis: 0` sets the button's HEIGHT, so a button
  // with a fixed height and no vertical padding (every DS 2.0 button) collapsed to its text line.

  [breakpoints.up('sm')]: {
    flexDirection: 'row',
    position: 'relative',
    alignItems: 'end',
    justifyContent: 'end',
    padding: 0,
  },
}));
